import { Component, OnInit } from '@angular/core';
import {MenuController, ModalController} from '@ionic/angular';
import { Router } from '@angular/router';
@Component({
  selector: 'app-medicalmap',
  templateUrl: './medicalmap.page.html',
  styleUrls: ['./medicalmap.page.scss'],
})
export class MedicalmapPage implements OnInit {
location: string = "n1";
  constructor(private modalController: ModalController, private route: Router, private menu: MenuController) { }

  ngOnInit() {
  }
    
 medicaldetail() {
    this.modalController.dismiss();
    this.route.navigate(['./medicaldetail']);
  }   
    
 dismiss(){
   this.modalController.dismiss();
 }
    ionViewWillEnter() {
        this.menu.enable(false);
    }
    ionViewWillLeave() {
        this.menu.enable(true);
    }
}
